import { requester } from "App";
import { useEffect, useState } from "react";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import CustomButton from "components/buttons/CustomButton";
import Center from "layouts/wrapper/Center";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import Container from "layouts/container/Container";
import style from "./PartnersCategoryRegister.module.css";
import CategoryCard from "routes/admin/category/CategoryCard";

function PartnersCategoryRegister() {
    const [isMounted, setMounted] = useState(false);
    const [columns, setColumns] = useState({});
    const { t } = useTranslation();

    useEffect(() => {
        requester.findAllCategories({ storeId: "root" }, (result) => {
            if (result.data) {
                const allCategories = result.data;
                const initialColumns = {
                    notRegistered: { title: "미등록", items: [] }
                };

                // 모든 최상위 카테고리(즉, parent_category_id가 null인 카테고리)를 컬럼으로 설정합니다.
                allCategories.forEach(category => {
                    if (category.parentCategoryId == null) { // parent_category_id가 null인 경우
                        initialColumns[category.id] = {
                            title: category.categoryName,
                            items: []
                        };
                    }
                });

                // parent_category_id가 null이 아닌 카테고리를 처리합니다.
                allCategories.forEach(category => {

                    if (category.parentCategoryId != null) { // parent_category_id가 null이 아닌 경우
                        const parentColumn = initialColumns[category.parentCategoryId];

                        if (parentColumn) {

                            parentColumn.items.push({
                                id: category.id,
                                title: category.categoryName,
                                parentCategoryId: category.parentCategoryId
                            });
                        } else {

                        }
                    } else {
                        // 디버깅을 위한 로그 추가

                        initialColumns.notRegistered.items.push({
                            id: category.id,
                            title: category.categoryName,
                            parentCategoryId: null
                        });
                    }
                });

                const topLevelCategoriesWithChildren = new Set();
                allCategories.forEach(category => {
                    if (category.parentCategoryId != null) {
                        topLevelCategoriesWithChildren.add(category.parentCategoryId);
                    }
                });

                // "미등록" 컬럼에 있는 항목들 중, 하위 카테고리를 가지고 있는 항목을 제거합니다.
                initialColumns.notRegistered.items = initialColumns.notRegistered.items.filter(item =>
                    !topLevelCategoriesWithChildren.has(item.id)
                );

                setColumns(initialColumns);
            }
        });
    }, []);

    const onDragEnd = (result) => {
        const { source, destination } = result;

        if (!destination) return;

        if (source.droppableId === destination.droppableId &&
            source.index === destination.index) {

            return; // 위치 변화가 없으므로 아무것도 하지 않음
        }

        // 이동되는 카테고리 객체를 가져옴
        const movedItem = { ...columns[source.droppableId].items[source.index] };

        // 자기 자신에게 드래그하는 경우 취소
        if (movedItem.id === destination.droppableId) {
            toast.error(t("같은 카테고리에 놓을 수 없습니다."), {
                autoClose: 1000,
                position: toast.POSITION.BOTTOM_CENTER
            });
            return;
        }


        // 하위 아이템을 가지고 있는지 확인하기 위해 모든 컬럼을 순회합니다.
        const hasChildItems = Object.values(columns).some(column =>
            column.items.some(item => item.parentCategoryId === movedItem.id)
        );

        if (hasChildItems) {
            // if (columns[movedItem.id] && columns[movedItem.id].items.length > 0) {
            //     toast.error(t("하위 카테고리를 가진 카테고리는 이동할 수 없습니다."), {
            //         autoClose: 1000,
            //         position: toast.POSITION.BOTTOM_CENTER
            //     });
            //     return;

            // }
            toast.error(t("하위 카테고리를 가진 카테고리는 이동할 수 없습니다."), {
                autoClose: 1000,
                position: toast.POSITION.BOTTOM_CENTER
            });
            return;
        }

        // 만약 이동하는 항목이 하위 항목을 가지고 있으면, 이동을 취소합니다.

        // if (columns[source.droppableId].items.find(item => item.parentCategoryId === movedItem.id)) {


        //     toast.error(t("하위 카테고리를 가진 카테고리는 이동할 수 없습니다."), {
        //         autoClose: 1000,
        //         position: toast.POSITION.BOTTOM_CENTER
        //     });
        //     return;
        // }

        // "미등록" 컬럼으로 이동하는 경우 parentCategoryId를 null로 설정
        movedItem.parentCategoryId = destination.droppableId === 'notRegistered' ? null : destination.droppableId;

        // 상태 업데이트를 위한 새로운 컬럼 객체 생성
        const newColumns = { ...columns };


        // 시작 컬럼에서 아이템 제거
        newColumns[source.droppableId].items =
            newColumns[source.droppableId].items.filter(item => item.id !== movedItem.id);


        // onDragEnd 함수 내부
        if (destination.droppableId !== 'notRegistered') {
            // 목적지 컬럼에 아이템을 추가합니다.
            const destinationItems = Array.from(newColumns[destination.droppableId].items);
            destinationItems.splice(destination.index, 0, movedItem);
            newColumns[destination.droppableId].items = destinationItems;

            // 만약 아이템이 미등록 컬럼에서 왔다면, 미등록 컬럼에서 해당 아이템을 제거합니다.
            if (source.droppableId === 'notRegistered') {
                newColumns[source.droppableId].items = newColumns[source.droppableId].items.filter(item => item.id !== movedItem.id);
            }
        } else {
            // 아이템을 미등록 컬럼에 추가합니다.
            newColumns['notRegistered'].items.splice(destination.index, 0, movedItem);
        }



        // 상태 업데이트
        setColumns(newColumns);
    };

    const onUpdateClick = async () => {
        try {
            const updatedCategories = await fetchUpdatedCategories(); // 서버로부터 업데이트된 카테고리를 받아옴
            const newColumns = reconstructColumns(updatedCategories); // 받아온 데이터로 새로운 컬럼 객체를 생성

            setColumns(newColumns); // 상태 업데이트
        } catch (error) {
            // 에러 핸들링

            toast.error(t("업데이트에 실패했습니다."));
        }
    }

    const reconstructColumns = (categories) => {


        if (categories) {
            const allCategories = categories;
            const initialColumns = {
                notRegistered: { title: "미등록", items: [] }
            };
            // 모든 최상위 카테고리를 컬럼으로 설정합니다.
            allCategories.forEach(category => {
                if (category.parentCategoryId == null) {
                    initialColumns[category.id] = {
                        title: category.categoryName,
                        items: []
                    };
                }
            });

            // parent_category_id가 null이 아닌 카테고리를 처리합니다.
            allCategories.forEach(category => {
                if (category.parentCategoryId != null) {
                    const parentColumn = initialColumns[category.parentCategoryId];
                    if (parentColumn) {
                        parentColumn.items.push({
                            id: category.id,
                            title: category.categoryName,
                            parentCategoryId: category.parentCategoryId
                        });
                    } // 여기 else 부분은 필요하다면 처리 로직을 추가해야 합니다.
                } else {
                    initialColumns.notRegistered.items.push({
                        id: category.id,
                        title: category.categoryName,
                        parentCategoryId: null
                    });
                }
            });

            const topLevelCategoriesWithChildren = new Set();
            allCategories.forEach(category => {
                if (category.parentCategoryId != null) {
                    topLevelCategoriesWithChildren.add(category.parentCategoryId);
                }
            });

            // "미등록" 컬럼에 있는 항목들 중, 하위 카테고리를 가지고 있는 항목을 제거합니다.
            initialColumns.notRegistered.items = initialColumns.notRegistered.items.filter(item =>
                !topLevelCategoriesWithChildren.has(item.id)
            );

            return initialColumns; // 생성된 컬럼 객체를 반환합니다.
        }
        return {}; // categories가 없다면 빈 객체를 반환합니다.
    }

    const fetchUpdatedCategories = () => {
        return new Promise((resolve, reject) => {
            const itemsToUpdate = Object.values(columns).flatMap(column => column.items.map(item => ({
                ...item,
                // 필요한 데이터 변환 로직
            })));



            requester.updateCategoryList(itemsToUpdate, (result) => {
                if (result.code === 0) {
                    toast.success(t("수정되었습니다"), {
                        autoClose: 1000,
                        position: toast.POSITION.BOTTOM_CENTER
                    });
                    resolve(result.data); // 성공 시 데이터를 반환
                } else {
                    reject(new Error("Server responded with an error")); // 실패 시 에러를 반환
                }
            });
        });
    }
    return (
        <Container>
            <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                <div className={style.wrap}>
                    <DragDropContext onDragEnd={(result) => onDragEnd(result, columns, setColumns)}>
                        <div className={style.container}>
                            {/* "미등록" 컬럼만 별도로 렌더링 */}
                            {columns && columns['notRegistered'] && (
                                <Droppable droppableId="notRegistered">
                                    {(provided, snapshot) => (
                                        <div
                                            className={`${style.list} ${style.notRegisteredColumn}`}
                                            ref={provided.innerRef}
                                            {...provided.droppableProps}
                                        >
                                            <span className={style.title}>{columns && columns['notRegistered'].title}</span>
                                            {columns && columns['notRegistered'].items.map((item, index) => (
                                                <CategoryCard key={item.id} item={item} index={index} />
                                            ))}
                                            {provided.placeholder}
                                        </div>
                                    )}
                                </Droppable>
                            )}

                            {/* 나머지 컬럼들을 가로로 나열 */}
                            <div className={style.otherColumns}>
                                {columns && columns && Object.entries(columns).map(([columnId, column], index) => {
                                    if (columnId !== 'notRegistered') {
                                        return (
                                            <Droppable key={columnId} droppableId={columnId}>
                                                {(provided, snapshot) => (
                                                    <div
                                                        className={`${style.list} ${style.otherColumn}`}
                                                        ref={provided.innerRef}
                                                        {...provided.droppableProps}
                                                    >
                                                        <span className={style.title}>{column.title ? column.title : "없음"}</span>
                                                        {column.items.map((item, index) => (
                                                            <CategoryCard key={item.id} item={item} index={index} />
                                                        ))}
                                                        {provided.placeholder}
                                                    </div>
                                                )}
                                            </Droppable>
                                        );
                                    }
                                    return null;
                                })}
                            </div>
                        </div>
                    </DragDropContext>
                </div>
                <div className={style.wrap}>
                    <Center width={"50%"}>
                        <CustomButton text={"적용"} onClick={onUpdateClick} />
                    </Center>
                </div>
            </div>
        </Container>
    );
} export default PartnersCategoryRegister;